module.exports = __webpack_public_path__ + "img/5-1.67c0afea.png";